var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full"},[_c('Tree',{ref:"res_tree",staticClass:"form-item-container",staticStyle:{"max-height":"500px","overflow-y":"auto"},attrs:{"data":_vm.resTree,"show-checkbox":"","check-directly":true},on:{"on-check-change":_vm.onSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }